import { UnitConvertible } from '@app/shared/units/base/unit-convertible';
import { pressureFactors } from '@app/shared/units/pressure/pressure-factors';
import { PressureUnit } from '@app/shared/units/pressure/pressure-unit.enum';

export class Pressure extends UnitConvertible<PressureUnit> {
  protected factors = pressureFactors;
}
